import { useRef } from "react";

import { GetWSMgr } from "@/Utils/StateLib";
import { useEventListener } from "@theorgchartdev/storybook";

export const DragItem = props => {
  const elementRef = useRef(null);

  useEventListener(
    "mousemove",
    e => {
      // If primary mouse is not held down, not a drag event
      if (e.buttons !== 1) {
        return;
      }

      const wsMgr = GetWSMgr();
      if (wsMgr.GetActiveDragPanel()) {
        return;
      }

      props?.onDragStart(e);
    },
    { elementRef }
  );

  return (
    <div ref={elementRef} {...props}>
      {props.children}
    </div>
  );
};
